import { AppState } from "../Common/Reducer/rootReducerTypes";
import { useSelector } from "../redux/store";

const useAuth = () => {
  const userState = useSelector((state: AppState) => state.user);
  const userInformationState = useSelector((state: AppState) => state.userInfo);

  return {
    initialized: !userInformationState.isLoadingUserInformation,
    authenticated: userState.isAuthenticated,
    userInformation: userInformationState.userInformation
  };
};

export default useAuth;